export const hexagramOverview = [
  {
    괘이름: '건(乾)',
    상괘: '건(乾)',
    하괘: '건(乾)',
    형상풀이:
      '하늘 위에 하늘이 겹친 모습으로, 지극히 건실하고 완전무결한 형상입니다.',
    의미: '건괘는 강건하고 창조적인 힘을 상징하며, 큰 성공과 리더십의 가능성을 내포하고 있습니다. 올바른 길을 간다면 큰 성취가 따를 것입니다.',
    전체괘명: '중천건',
  },
  {
    괘이름: '곤(坤)',
    상괘: '곤(坤)',
    하괘: '곤(坤)',
    형상풀이: '땅 위에 또 다른 땅이 겹친 모습으로, 포용력과 순응의 상징입니다.',
    의미: '곤괘는 수용성과 양보의 미덕을 상징합니다. 겸손하고 따르는 자세를 가지면 복이 따를 것입니다.',
    전체괘명: '중지곤',
  },
  {
    괘이름: '둔(屯)',
    상괘: '감(坎)',
    하괘: '진(震)',
    형상풀이:
      '위에는 물이 흐르고 아래는 우레가 이는 모습으로, 새롭게 시작되는 상황 속의 어려움을 나타냅니다.',
    의미: '처음 시작하는 일에는 어려움이 따르기 마련입니다. 인내와 준비가 필요하며, 조심스럽게 나아가면 길할 수 있습니다.',
    전체괘명: '수뢰둔',
  },
  {
    괘이름: '몽(蒙)',
    상괘: '간(艮)',
    하괘: '감(坎)',
    형상풀이:
      '산 아래 물이 고인 모습으로, 무지함과 배움의 필요성을 상징합니다.',
    의미: '배움이 필요한 시기입니다. 겸손한 자세로 가르침을 구하면 길하며, 완고하게 굴면 해로울 수 있습니다.',
    전체괘명: '산수몽',
  },
  {
    괘이름: '수(需)',
    상괘: '감(坎)',
    하괘: '건(乾)',
    형상풀이:
      '물 아래 하늘이 있는 모습으로, 기다림과 준비의 시간을 나타냅니다.',
    의미: '때를 기다리는 것이 중요합니다. 조급함은 해가 되며, 충분히 준비한 후 움직여야 성공할 수 있습니다.',
    전체괘명: '수천수',
  },
  {
    괘이름: '송(訟)',
    상괘: '건(乾)',
    하괘: '감(坎)',
    형상풀이:
      '물 위에 하늘이 있는 모습으로, 논쟁이나 분쟁의 가능성을 의미합니다.',
    의미: '갈등 상황에서는 진실과 정의에 따라 행동해야 합니다. 감정적인 대응은 해가 되며, 이성적인 해결이 요구됩니다.',
    전체괘명: '천수송',
  },
  {
    괘이름: '사(師)',
    상괘: '곤(坤)',
    하괘: '감(坎)',
    형상풀이:
      '땅 아래 물이 있는 모습으로, 군대가 질서 있게 움직이는 형상입니다.',
    의미: '사괘는 조직과 질서를 갖춘 집단의 움직임을 상징합니다. 지도자는 덕을 갖추고 신중하게 행동해야 하며, 정의로운 목적 아래 인도하면 길합니다.',
    전체괘명: '지수사',
  },
  {
    괘이름: '비(比)',
    상괘: '감(坎)',
    하괘: '곤(坤)',
    형상풀이: '물 아래에 땅이 있는 형상으로, 서로 가까이 모이는 모습입니다.',
    의미: '비괘는 친밀함과 협력을 상징합니다. 진실한 마음으로 사람들과 어울리되, 올바른 이와 함께해야 길합니다.',
    전체괘명: '수지비',
  },
  {
    괘이름: '소축(小畜)',
    상괘: '손(巽)',
    하괘: '건(乾)',
    형상풀이:
      '바람이 하늘 위를 부는 모습으로, 작은 힘이 큰 것을 잠시 머물게 하는 형상입니다.',
    의미: '소축괘는 작지만 강한 제어력을 뜻하며, 지금은 억제하고 머무를 때입니다. 꾸준히 준비하면 길한 때가 찾아올 것입니다.',
    전체괘명: '풍천소축',
  },
  {
    괘이름: '리(履)',
    상괘: '건(乾)',
    하괘: '태(兌)',
    형상풀이:
      '하늘 아래에 못이 있는 모습으로, 예의를 지켜 도리를 따르는 형상입니다.',
    의미: '리괘는 예절과 규범을 상징합니다. 순리를 따르고 조심스럽게 행동하면 위험을 피하고 길함을 얻게 됩니다.',
    전체괘명: '천택리',
  },
  {
    괘이름: '태(泰)',
    상괘: '곤(坤)',
    하괘: '건(乾)',
    형상풀이:
      '하늘이 아래에 있고 땅이 위에 있는 모습으로, 상하가 통하여 태평함이 이루어진 형상입니다.',
    의미: '태괘는 하늘과 땅이 서로 교통하여 세상이 조화를 이루는 상서로운 시기를 상징합니다. 큰 일을 도모하기에 좋은 시기입니다.',
    전체괘명: '지천태',
  },
  {
    괘이름: '비(否)',
    상괘: '건(乾)',
    하괘: '곤(坤)',
    형상풀이:
      '하늘이 위에 있고 땅이 아래에 있는 모습으로, 상하가 단절되어 소통이 막힌 형상입니다.',
    의미: '비괘는 교류가 끊기고 도가 막힌 상태를 상징합니다. 불통의 시기이므로 무리한 추진은 삼가고, 때를 기다려야 합니다.',
    전체괘명: '천지비',
  },
  {
    괘이름: '동인(同人)',
    상괘: '건(乾)',
    하괘: '리(離)',
    형상풀이:
      '하늘 아래에 불이 있는 형상으로, 공동의 뜻을 가진 사람들이 모이는 모습입니다.',
    의미: '동인괘는 같은 뜻을 가진 이들이 모여 조화를 이루는 것을 뜻합니다. 진심으로 화합하면 큰일도 이룰 수 있습니다.',
    전체괘명: '천화동인',
  },
  {
    괘이름: '대유(大有)',
    상괘: '리(離)',
    하괘: '건(乾)',
    형상풀이: '불이 하늘 위에 있는 형상으로, 밝은 덕이 위에 있는 모습입니다.',
    의미: '대유괘는 큰 소유와 성취를 상징합니다. 밝고 올바른 덕을 갖추면 부귀와 성공이 따르게 됩니다.',
    전체괘명: '화천대유',
  },
  {
    괘이름: '겸(謙)',
    상괘: '곤(坤)',
    하괘: '간(艮)',
    형상풀이: '땅 아래에 산이 있는 형상으로, 겸손히 자신을 낮추는 모습입니다.',
    의미: '겸괘는 겸손을 통해 복을 이루는 괘입니다. 스스로를 낮추고 덕을 쌓으면 사람들이 따르게 됩니다.',
    전체괘명: '지산겸',
  },
  {
    괘이름: '예(豫)',
    상괘: '진(震)',
    하괘: '곤(坤)',
    형상풀이: '우레가 땅 위에 있는 형상으로, 기쁨이 퍼지는 모습입니다.',
    의미: '예괘는 즐거움과 예비를 상징합니다. 기쁨이 넘칠 때일수록 앞날을 대비하고 절도를 지키면 길합니다.',
    전체괘명: '뇌지예',
  },
  {
    괘이름: '수(隨)',
    상괘: '태(兌)',
    하괘: '진(震)',
    형상풀이:
      '못 아래 우레가 이는 형상으로, 기꺼이 따르고 순응하는 모습입니다.',
    의미: '수괘는 기운이 강한 자를 따르는 순응의 도리를 나타냅니다. 스스로 나아가기보다 때를 따라가며 유연하게 처신하면 길합니다.',
    전체괘명: '택뢰수',
  },
  {
    괘이름: '고(蠱)',
    상괘: '간(艮)',
    하괘: '손(巽)',
    형상풀이:
      '산 아래로 바람이 스며드는 형상으로, 내부에 쌓인 병폐를 드러내는 모습입니다.',
    의미: '고괘는 오래된 문제나 부패를 바로잡아야 할 시기를 나타냅니다. 근본부터 정비하고 개혁을 단행하면 새롭게 나아갈 수 있습니다.',
    전체괘명: '산풍고',
  },
  {
    괘이름: '임(臨)',
    상괘: '곤(坤)',
    하괘: '태(兌)',
    형상풀이:
      '땅 아래 못이 있는 형상으로, 아랫사람을 살피고 지도하는 모습입니다.',
    의미: '임괘는 지도자의 자세를 상징합니다. 부드러움으로 사람을 이끌고 신중하게 행동하면 존경을 얻게 됩니다.',
    전체괘명: '지택임',
  },
  {
    괘이름: '관(觀)',
    상괘: '손(巽)',
    하괘: '곤(坤)',
    형상풀이:
      '바람이 땅 위를 부는 형상으로, 위에서 아래를 살피며 본을 보이는 모습입니다.',
    의미: '관괘는 관찰과 모범을 뜻합니다. 자신을 단정히 하여 백성들에게 모범을 보이면 덕이 널리 퍼집니다.',
    전체괘명: '풍지관',
  },
  {
    괘이름: '서합(噬嗑)',
    상괘: '리(離)',
    하괘: '진(震)',
    형상풀이: '불 아래에 우레가 있는 형상으로, 장애를 물어 끊는 모습입니다.',
    의미: '서합괘는 얽히고 막힌 것을 제거하고 질서를 회복하는 뜻입니다. 단호하게 잘못을 다스리면 길합니다.',
    전체괘명: '화뢰서합',
  },
  {
    괘이름: '분(賁)',
    상괘: '간(艮)',
    하괘: '리(離)',
    형상풀이: '산 아래에 불이 있는 형상으로, 빛이 산을 밝히는 모습입니다.',
    의미: '분괘는 장식과 문화를 의미합니다. 내실을 바탕으로 겉을 아름답게 하면 사람들의 마음을 얻을 수 있습니다.',
    전체괘명: '산화분',
  },
  {
    괘이름: '박(剝)',
    상괘: '간(艮)',
    하괘: '곤(坤)',
    형상풀이: '산이 땅 위에 있는 형상으로, 바깥이 점점 깎여 나가는 모습입니다.',
    의미: '박괘는 쇠퇴와 붕괴의 조짐을 나타냅니다. 끝까지 도를 지키고 안으로 힘을 기르면 다시 회복의 기회를 얻게 됩니다.',
    전체괘명: '산지박',
  },
  {
    괘이름: '복(復)',
    상괘: '곤(坤)',
    하괘: '진(震)',
    형상풀이:
      '땅 아래에 우레가 있는 형상으로, 움직임이 다시 시작되는 모습입니다.',
    의미: '복괘는 끝났던 일이 다시 돌아오는 회복과 순환의 기운을 상징합니다. 잘못을 바로잡고 도를 따르면 다시 길한 시기가 옵니다.',
    전체괘명: '지뢰복',
  },
  {
    괘이름: '무망(無妄)',
    상괘: '건(乾)',
    하괘: '진(震)',
    형상풀이:
      '하늘 아래에 우레가 있는 형상으로, 자연의 뜻을 따르는 모습입니다.',
    의미: '무망괘는 거짓됨이 없는 참된 행동을 뜻합니다. 순수한 마음으로 움직이면 형통하나, 인위적인 꾀는 해로울 수 있습니다.',
    전체괘명: '천뢰무망',
  },
  {
    괘이름: '대축(大畜)',
    상괘: '간(艮)',
    하괘: '건(乾)',
    형상풀이: '산 아래에 하늘이 있는 형상으로, 큰 것을 머금고 있는 모습입니다.',
    의미: '대축괘는 큰 힘을 안으로 기르는 시기입니다. 때를 기다리며 힘을 기르면 이후 큰일을 이룰 수 있습니다.',
    전체괘명: '산천대축',
  },
  {
    괘이름: '이(頤)',
    상괘: '간(艮)',
    하괘: '진(震)',
    형상풀이:
      '산 아래에 우레가 있는 형상으로, 입을 통해 양분을 취하는 모습입니다.',
    의미: '이괘는 양육과 절도를 의미합니다. 말과 행동을 삼가고, 바르게 살아야 복이 따릅니다.',
    전체괘명: '산뢰이',
  },
  {
    괘이름: '대과(大過)',
    상괘: '태(兌)',
    하괘: '손(巽)',
    형상풀이:
      '못 아래에 바람이 있는 형상으로, 무게 중심이 기울어진 모습입니다.',
    의미: '대과괘는 지나침과 과중함을 뜻합니다. 중도를 잃지 않도록 주의하며, 무거운 책임은 신중히 감당해야 합니다.',
    전체괘명: '택풍대과',
  },
  {
    괘이름: '감(坎)',
    상괘: '감(坎)',
    하괘: '감(坎)',
    형상풀이: '물 위에 또 물이 있는 형상으로, 거듭된 험난함을 뜻합니다.',
    의미: '감괘는 어려움과 시련을 상징합니다. 두려움을 극복하고 정정당당하게 나아가면 마침내 위기를 넘길 수 있습니다.',
    전체괘명: '중수감',
  },
  {
    괘이름: '리(離)',
    상괘: '리(離)',
    하괘: '리(離)',
    형상풀이: '불 위에 불이 겹쳐진 형상으로, 밝음과 통찰을 상징합니다.',
    의미: '리괘는 밝음과 분별을 의미합니다. 분명한 원칙과 올바른 판단을 세우고 중심을 지키면 길합니다.',
    전체괘명: '중화리',
  },
  {
    괘이름: '함(咸)',
    상괘: '태(兌)',
    하괘: '간(艮)',
    형상풀이: '못 아래에 산이 있는 형상으로, 감응하고 끌리는 모습입니다.',
    의미: '함괘는 감응과 교감을 상징합니다. 진심으로 대하면 상대의 마음도 움직이며, 조화로운 관계가 이루어집니다.',
    전체괘명: '택산함',
  },
  {
    괘이름: '항(恒)',
    상괘: '진(震)',
    하괘: '손(巽)',
    형상풀이:
      '우레 아래에 바람이 있는 형상으로, 자연의 순환처럼 오래 지속되는 모습입니다.',
    의미: '항괘는 끊임없이 지속되는 도리를 상징합니다. 일관된 태도와 성실함으로 나아가면 안정된 성과를 이룰 수 있습니다.',
    전체괘명: '뇌풍항',
  },
  {
    괘이름: '둔(遯)',
    상괘: '건(乾)',
    하괘: '간(艮)',
    형상풀이: '하늘 아래에 산이 있는 형상으로, 물러나 숨는 모습입니다.',
    의미: '둔괘는 시기가 좋지 않을 때는 물러나 때를 기다려야 함을 뜻합니다. 겸손히 숨고 도를 지키면 나중에 다시 나아갈 수 있습니다.',
    전체괘명: '천산둔',
  },
  {
    괘이름: '대장(大壯)',
    상괘: '진(震)',
    하괘: '건(乾)',
    형상풀이: '우레가 하늘 위에서 울리는 형상으로, 큰 힘이 충만한 모습입니다.',
    의미: '대장괘는 강한 기운이 드러나는 시기를 상징합니다. 힘에 치우치지 말고 도리에 맞게 절제하면 길합니다.',
    전체괘명: '뇌천대장',
  },
  {
    괘이름: '진(晉)',
    상괘: '리(離)',
    하괘: '곤(坤)',
    형상풀이: '불이 땅 위를 비추는 형상으로, 밝음이 점차 드러나는 모습입니다.',
    의미: '진괘는 출세와 진보를 뜻합니다. 밝은 덕과 올바른 뜻으로 나아가면 상승의 기운이 따릅니다.',
    전체괘명: '화지진',
  },
  {
    괘이름: '명이(明夷)',
    상괘: '곤(坤)',
    하괘: '리(離)',
    형상풀이: '땅 아래에 불이 있는 형상으로, 빛이 가려진 모습입니다.',
    의미: '명이괘는 어두운 시대를 상징합니다. 진실을 지키되 드러내지 말고, 내면의 빛을 간직하면 길합니다.',
    전체괘명: '지화명이',
  },
  {
    괘이름: '가인(家人)',
    상괘: '손(巽)',
    하괘: '리(離)',
    형상풀이:
      '바람이 불을 도와 밝히는 형상으로, 가정이 조화를 이루는 모습입니다.',
    의미: '가인괘는 집안을 다스리는 도리를 말합니다. 각자가 제 자리를 지키고 덕을 쌓으면 집안이 화목해집니다.',
    전체괘명: '풍화가인',
  },
  {
    괘이름: '규(睽)',
    상괘: '리(離)',
    하괘: '태(兌)',
    형상풀이: '불과 못이 서로 등을 지는 형상으로, 뜻이 어긋나는 모습입니다.',
    의미: '규괘는 불화와 분열을 나타냅니다. 그러나 서로 다름을 이해하고 조화롭게 소통하면 갈등을 해소할 수 있습니다.',
    전체괘명: '화택규',
  },
  {
    괘이름: '건(蹇)',
    상괘: '감(坎)',
    하괘: '간(艮)',
    형상풀이:
      '물이 산 위에 있는 형상으로, 앞으로 나아가기 어려운 장애가 있는 모습입니다.',
    의미: '건괘는 장애와 곤란을 상징합니다. 섣불리 움직이지 말고, 조심스럽게 대비하며 도움을 구하면 길합니다.',
    전체괘명: '수산건',
  },
  {
    괘이름: '해(解)',
    상괘: '진(震)',
    하괘: '감(坎)',
    형상풀이:
      '우레가 물 위에서 울리는 형상으로, 얽힌 것을 풀고 시원하게 되는 모습입니다.',
    의미: '해괘는 해소와 해방을 뜻합니다. 어려움이 풀리고 평안을 되찾을 수 있는 시기이니 적극적으로 나아가도 좋습니다.',
    전체괘명: '뇌수해',
  },
  {
    괘이름: '손(損)',
    상괘: '간(艮)',
    하괘: '태(兌)',
    형상풀이:
      '산 아래에 못이 있는 형상으로, 덜어내고 줄이는 가운데 조화를 이루는 모습입니다.',
    의미: '손괘는 손실이 아닌 조화를 위한 절제와 양보를 뜻합니다. 스스로를 낮추고 베풀면 큰 복이 따릅니다.',
    전체괘명: '산택손',
  },
  {
    괘이름: '익(益)',
    상괘: '손(巽)',
    하괘: '진(震)',
    형상풀이:
      '바람이 우레 위에서 부는 형상으로, 점점 이익이 더해지는 모습입니다.',
    의미: '익괘는 더함과 도움을 뜻합니다. 자신보다 남을 먼저 생각하면 복이 돌아오며, 꾸준한 노력은 결실로 이어집니다.',
    전체괘명: '풍뢰익',
  },
  {
    괘이름: '쾌(夬)',
    상괘: '태(兌)',
    하괘: '건(乾)',
    형상풀이:
      '못이 하늘 위에 있는 형상으로, 결단을 내려 과단성 있게 나아가는 모습입니다.',
    의미: '쾌괘는 과감한 결단의 시기입니다. 망설이지 말고 정의에 따라 행동하면 큰일을 이룰 수 있습니다.',
    전체괘명: '택천쾌',
  },
  {
    괘이름: '구(姤)',
    상괘: '건(乾)',
    하괘: '손(巽)',
    형상풀이:
      '하늘 아래에 바람이 있는 형상으로, 우연한 만남이나 인연을 뜻합니다.',
    의미: '구괘는 뜻밖의 만남이나 기회를 의미합니다. 그러나 경거망동하지 말고 중심을 지키면 좋은 인연으로 발전할 수 있습니다.',
    전체괘명: '천풍구',
  },
  {
    괘이름: '췌(萃)',
    상괘: '태(兌)',
    하괘: '곤(坤)',
    형상풀이: '못 아래에 땅이 있는 형상으로, 많은 이들이 모이는 모습입니다.',
    의미: '췌괘는 모임과 집합을 상징합니다. 올바른 중심 아래 사람들이 모이면 큰 일을 도모할 수 있습니다.',
    전체괘명: '택지췌',
  },
  {
    괘이름: '승(升)',
    상괘: '곤(坤)',
    하괘: '손(巽)',
    형상풀이: '땅 아래에서 바람이 올라오는 형상으로, 점차 상승하는 모습입니다.',
    의미: '승괘는 나아감과 승진을 뜻합니다. 천천히 그러나 꾸준히 쌓아 올리면 결국 높은 곳에 도달하게 됩니다.',
    전체괘명: '지풍승',
  },
  {
    괘이름: '곤(困)',
    상괘: '태(兌)',
    하괘: '감(坎)',
    형상풀이: '못 아래에 물이 있는 형상으로, 진퇴양난의 곤궁한 모습입니다.',
    의미: '곤괘는 어려움과 고난의 시기를 뜻합니다. 마음을 굳게 하고 도움을 구하며 인내하면 극복할 수 있습니다.',
    전체괘명: '택수곤',
  },
  {
    괘이름: '정(井)',
    상괘: '감(坎)',
    하괘: '손(巽)',
    형상풀이:
      '우물처럼 물이 바람 아래에 있는 형상으로, 생명의 근원이 되는 모습입니다.',
    의미: '정괘는 공동의 기반과 근본을 상징합니다. 본분을 다하고 자신을 갈고닦으면 공동체에 이로움이 돌아옵니다.',
    전체괘명: '수풍정',
  },
  {
    괘이름: '혁(革)',
    상괘: '태(兌)',
    하괘: '리(離)',
    형상풀이:
      '못 아래에 불이 있는 형상으로, 묵은 것을 벗겨내는 개혁의 모습입니다.',
    의미: '혁괘는 낡은 질서를 버리고 새롭게 나아가는 것을 의미합니다. 바른 뜻 아래 개혁하면 큰 변화를 이룰 수 있습니다.',
    전체괘명: '택화혁',
  },
  {
    괘이름: '정(鼎)',
    상괘: '리(離)',
    하괘: '손(巽)',
    형상풀이: '불 아래에 바람이 있는 형상으로, 솥이 잘 타오르는 모습입니다.',
    의미: '정괘는 큰 그릇과 문명의 완성을 상징합니다. 중심을 바로 세우고 덕을 갖추면 귀한 존재가 될 수 있습니다.',
    전체괘명: '화풍정',
  },
  {
    괘이름: '진(震)',
    상괘: '진(震)',
    하괘: '진(震)',
    형상풀이: '우레가 거듭 치는 형상으로, 강하게 움직이며 시작되는 모습입니다.',
    의미: '진괘는 움직임과 시작을 뜻합니다. 놀라움 속에서 바르게 행동하면 길하며, 망설임 없이 전진하는 태도가 필요합니다.',
    전체괘명: '중뢰진',
  },
  {
    괘이름: '간(艮)',
    상괘: '간(艮)',
    하괘: '간(艮)',
    형상풀이: '산이 겹쳐 있는 형상으로, 멈춤과 안정의 모습입니다.',
    의미: '간괘는 그침과 자제를 상징합니다. 멈춰야 할 때 멈추고 내면을 성찰하면 길하며, 억지로 나아가면 해가 됩니다.',
    전체괘명: '중산간',
  },
  {
    괘이름: '점(漸)',
    상괘: '손(巽)',
    하괘: '간(艮)',
    형상풀이:
      '바람이 산을 따라 점차 스며드는 형상으로, 점진적인 발전을 의미합니다.',
    의미: '점괘는 서두르지 않고 한 걸음씩 나아가는 도리를 말합니다. 천천히 그러나 착실하게 나아가면 큰 성과로 이어집니다.',
    전체괘명: '풍산점',
  },
  {
    괘이름: '귀매(歸妹)',
    상괘: '진(震)',
    하괘: '태(兌)',
    형상풀이: '우레 아래에 못이 있는 형상으로, 시집가는 여인의 모습입니다.',
    의미: '귀매괘는 결합과 관계의 시작을 의미합니다. 바른 절차를 따르고 조화를 이룬다면 좋은 인연으로 이어질 수 있습니다.',
    전체괘명: '뇌택귀매',
  },
  {
    괘이름: '풍(豐)',
    상괘: '진(震)',
    하괘: '리(離)',
    형상풀이:
      '우레와 불이 함께하는 형상으로, 밝음과 성대함이 극에 이른 모습입니다.',
    의미: '풍괘는 번영과 충실함을 상징합니다. 외적으로 화려하지만 내실을 갖추어야 지속적인 복을 이룰 수 있습니다.',
    전체괘명: '뇌화풍',
  },
  {
    괘이름: '려(旅)',
    상괘: '리(離)',
    하괘: '간(艮)',
    형상풀이: '불이 산 위에 있는 형상으로, 타향살이나 유랑의 모습입니다.',
    의미: '려괘는 낯선 곳에서의 삶과 이동을 의미합니다. 겸손하고 예의를 지키면 타지에서도 복을 받을 수 있습니다.',
    전체괘명: '화산려',
  },
  {
    괘이름: '손(巽)',
    상괘: '손(巽)',
    하괘: '손(巽)',
    형상풀이: '바람이 거듭 부는 형상으로, 부드럽게 퍼지는 영향력의 모습입니다.',
    의미: '손괘는 유연함과 겸손을 상징합니다. 강압보다 온화한 접근이 더 큰 영향을 미칠 수 있습니다.',
    전체괘명: '중풍손',
  },
  {
    괘이름: '태(兌)',
    상괘: '태(兌)',
    하괘: '태(兌)',
    형상풀이: '못이 겹쳐 있는 형상으로, 기쁨과 유연함이 가득한 모습입니다.',
    의미: '태괘는 기쁨과 조화, 평화를 상징합니다. 말과 행동이 부드럽고 즐거우면 사람들과의 관계가 원만해집니다.',
    전체괘명: '중택태',
  },
  {
    괘이름: '환(渙)',
    상괘: '손(巽)',
    하괘: '감(坎)',
    형상풀이: '바람이 물을 흩트리는 형상으로, 흩어짐과 해산을 뜻합니다.',
    의미: '환괘는 긴장이 풀리고 막힘이 흩어지는 시기입니다. 흩어진 뒤 다시 모일 수 있도록 중심을 잘 잡아야 합니다.',
    전체괘명: '풍수환',
  },
  {
    괘이름: '절(節)',
    상괘: '감(坎)',
    하괘: '태(兌)',
    형상풀이: '물이 못 위에 있는 형상으로, 절제와 규범의 모습입니다.',
    의미: '절괘는 분수를 지키고 절도 있게 행동하는 것을 뜻합니다. 지나침을 경계하고 본분을 지키면 길합니다.',
    전체괘명: '수택절',
  },
  {
    괘이름: '중부(中孚)',
    상괘: '손(巽)',
    하괘: '태(兌)',
    형상풀이:
      '바람과 못이 서로 응하는 형상으로, 진실이 중심에 있는 모습입니다.',
    의미: '중부괘는 참된 믿음과 진실한 마음을 상징합니다. 진정성 있는 태도로 사람을 대하면 신뢰를 얻게 됩니다.',
    전체괘명: '풍택중부',
  },
  {
    괘이름: '소과(小過)',
    상괘: '진(震)',
    하괘: '간(艮)',
    형상풀이: '우레가 산 위에서 울리는 형상으로, 조금 지나친 모습입니다.',
    의미: '소과괘는 작게 넘침을 뜻합니다. 작은 일에는 힘쓰되, 큰일에는 무리하지 않는 것이 중요합니다.',
    전체괘명: '뇌산소과',
  },
  {
    괘이름: '기제(既濟)',
    상괘: '감(坎)',
    하괘: '리(離)',
    형상풀이: '물이 불 위에 있는 형상으로, 모든 것이 갖추어진 상태입니다.',
    의미: '기제괘는 일이 이미 이루어진 상태를 나타냅니다. 그러나 자만하지 말고 끝까지 유종의 미를 거두는 것이 중요합니다.',
    전체괘명: '수화기제',
  },
  {
    괘이름: '미제(未濟)',
    상괘: '리(離)',
    하괘: '감(坎)',
    형상풀이: '불이 물 위에 있는 형상으로, 아직 이루어지지 않은 모습입니다.',
    의미: '미제괘는 미완성과 준비의 시기입니다. 서두르지 말고 부족한 것을 채워나가야 비로소 완성에 이를 수 있습니다.',
    전체괘명: '화수미제',
  },
]
